











import { namespace } from 'vuex-class';
import { Component, Vue } from 'vue-property-decorator';
import { CART } from '@/store/types';
import { ApiService } from '@/services/ApiService';
import PromotedProductCartItem from '@/cart-page/cart/section/PromotedProductCartItem.vue';
import { ProductDto } from '@eurogast/hub-client-typescript';
import { DependencyService } from '@/services/DependencyService';

const cart = namespace(CART);

@Component({
  components: {
    PromotedProductCartItem
  }
})
export default class PromotedProductSection extends Vue {
  public promotedProducts: ProductDto[] = [];

  private productsService = DependencyService.defaultProductService();

  public mounted() {
    this.productsService.getCartPromotedProducts()
        .then((result) => this.promotedProducts.push(...result))
        .catch(ApiService.defaultErrorHandler);
  }
}
